import React from "react";

const MemberBanner = ({ isFree, freeUntil, bannerMessage }) => {
  if (bannerMessage.memberBannerMessage === "" && bannerMessage.nonMemberBannerMessage === "") {
    return null
  }
  return (
    <div className="bg-orange-brand-500">
      <div className="max-w-screen-xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-center flex-wrap">
          <div className="w-0 flex-1 flex justify-center">
            <span className="flex self-center p-2 rounded-lg bg-indigo-800">
              <svg
                className="h-6 w-6 text-white"
                stroke="currentColor"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z"
                />
              </svg>
            </span>
            <div className="ml-3 font-medium text-white flex flex-col justify-center text-center">
              {isFree ? (
                <>
                  {
                    bannerMessage.memberBannerMessage && (
                      <b dangerouslySetInnerHTML={{ __html: bannerMessage.memberBannerMessage }} />
                    )
                  }
                </>
              ) : (
                <>
                  {
                    bannerMessage.memberBannerMessage && (
                      <b dangerouslySetInnerHTML={{ __html: bannerMessage.memberBannerMessage }} />
                    )
                  }
                </>
              )
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MemberBanner;
